<script>
    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        components: {
            Vue3Autocounter
        },
        mixins: [mixin],
        props: {
            data: Object,
        },
        data() {
            return {
                activeFilter: '',
                name: 'rentalDataStatus',
                facetAlias: 'status_huurcontract',
            };
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            filters() {
                if (!this.facetsSet) return [];
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return [];
                return facet.options.filter(o => o.filteredAmount).map(option => ({
                    label: option.valueAlias,
                    count: option.filteredAmount
                }));
            },
        },
        methods: {
            onFilterSelect(filter) {
                if (!filter) return;
                const filterChosen = filter.label === this.activeFilter;
                this.activeFilter = filterChosen ? '' : filter.label;

                this.$emit('filter', {
                    type: this.name,
                    value: this.activeFilter
                });
            }
        },
    };
</script>

<template>
    <div v-if="filters.length" class="is-flex is-fullheight dashboard-widget--filter">
        <div class="buttons has-addons is-align-items-stretch is-flex-wrap-nowrap is-fullwidth">
            <button v-for="filter in filters"
                    :key="filter.label"
                    :class="['button', $store.getters.getHighContrast ? 'is-quaternary' : 'is-tertiary', 'is-multiline', 'is-toggle', 'is-flex-grow-1', { 'is-selected': filter.label === activeFilter }, { 'is-outlined': filter.label !== activeFilter }]"
                    @click="onFilterSelect(filter)">
                <small class="has-text-weight-bold">{{ capitalize(filter.label) }}</small>
                <small><vue3-autocounter :endAmount="filter.count" separator="." duration="0.5" /></small>
            </button>
        </div>
    </div>
</template>
